import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";

const STEPS = [
  { n: "01", title: "Audit", text: "Full technical, content and competitive diagnosis of your website and market." },
  { n: "02", title: "Strategy", text: "A prioritized roadmap: keywords, pages, fixes and content mapped to business value." },
  { n: "03", title: "Optimize", text: "Technical fixes, on-page improvements and structural cleanup go live first." },
  { n: "04", title: "Create", text: "Intent-matched content that answers real searches and builds topical authority." },
  { n: "05", title: "Build", text: "Ethical authority: relevant links, citations, mentions and digital PR." },
  { n: "06", title: "Measure & Improve", text: "Transparent reporting feeds the next cycle. SEO compounds when measured." },
];

export function Process() {
  return (
    <section className="py-16 sm:py-24 lg:py-32" data-testid="process-section">
      <div className="container-rw">
        <SectionHead
          eyebrow="How SEO Works Here"
          title="Six steps. Repeated until it compounds."
          testid="process-head"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.07}>
              <div className="group relative h-full overflow-hidden rounded-2xl border border-rw-border bg-rw-card p-7 transition-all duration-300 hover:border-rw-blue/50"
                data-testid={`process-step-${s.n}`}>
                <span className="absolute -right-3 -top-6 font-jakarta text-8xl font-extrabold text-rw-border/40 transition-colors duration-300 group-hover:text-rw-blue/15 select-none" aria-hidden="true">
                  {s.n}
                </span>
                <span className="font-mono text-xs text-rw-blue">{s.n}</span>
                <h3 className="mt-3 font-jakarta text-lg font-bold uppercase tracking-wide text-rw-text">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-rw-muted">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
